import { InsightReportRow } from "../../interfaces/analytics/InsightReportRow";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

async function fetchInsightReport(
  authToken: string,
  endpoint: string
): Promise<InsightReportRow[] | null> {
  try {
    const response = await fetch(`${API_BASE_URL}/Insights/${endpoint}`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
    });


    if (!response.ok) {
      console.error("Failed to fetch insight report:", response);
      return null;
    }

    const data = await response.json();
    console.log(data); 
    return data;
  } catch (error) {
    console.error("Error fetching insight report:", error);
    return null;
  }
}

export const getExpiredCpocReport = (authToken: string) =>
  fetchInsightReport(authToken, "expired-cpoc-report");

export const get90DayCpocReport = (authToken: string) =>
  fetchInsightReport(authToken, "90-day-cpoc-report");

export const getNoCpocReport = (authToken: string) =>
  fetchInsightReport(authToken, "no-cpoc-report");
